import * as React from 'react';
import { Dialog, Snackbar } from 'material-ui';
import { compose, withState, withHandlers, defaultProps } from 'recompose';
import { noop } from 'lodash';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Loader } from '@components/loader';

const enhance = compose<any, any>(
  defaultProps({
    style: {},
    icon: null,
    dialogStyles: {},
    label: '',
    onCloseItem: noop,
    ModalComponent: () => <div>Add ModalComponent to ModalButton</div>
  }),
  withState('showModal', 'handleShowModal', false),
  withState('snackbar', 'handleSnackbar', ''),
  withState('loader', 'handleLoader', false),
  withHandlers({
    onClick: ({ onClick, handleShowModal }) => async props => {
      if (onClick) {
        await onClick(props);
      }
      handleShowModal(true);
    },
    closeItem: ({ onCloseItem, handleShowModal }) => async () => {
      await onCloseItem();
      handleShowModal(false);
    },
    handleCloseSnackbar: ({ handleSnackbar }) => () => handleSnackbar('')
  })
);

const View = ({
  showModal,
  closeItem,
  ModalComponent,
  label,
  onClick,
  icon,
  style,
  loader,
  disabled,
  snackbar,
  handleCloseSnackbar,
  dialogStyles,
  ...rest
}) => (
  <React.Fragment>
    <Button label={label} icon={icon} onClick={onClick} style={style} disabled={disabled}>
      <Dialog
        repositionOnUpdate={false}
        style={{ paddingTop: '20vh' }}
        contentStyle={{
          paddingTop: 10,
          transform: 'none'
        }}
        bodyStyle={{ padding: '0' }}
        open={showModal}
        onRequestClose={closeItem}
        {...dialogStyles}
      >
        <ModalComponent closeItem={closeItem} {...rest} />
        {loader && <Loader />}
      </Dialog>
    </Button>
    <Snackbar
      open={!!snackbar}
      message={snackbar}
      autoHideDuration={10000}
      bodyStyle={{ backgroundColor: '#39579e' }}
      onRequestClose={handleCloseSnackbar}
      contentStyle={{ textAlign: 'center' }}
    />
  </React.Fragment>
);

export const ModalButton = enhance(View);



// WEBPACK FOOTER //
// ./src/components/modalButton/ModalButton.tsx